import { login, logins, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    buttons: [],
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_ID: (state,dtkp)=>{
      state.dtkp = dtkp
    },
    // 按钮
    SET_BUTTONS: (state, buttons) => {
      state.buttons = buttons
    },
  },

  actions: {
    // 登录
    // Login({ commit }, userInfo) {
    //   const username = userInfo.username.trim()
    //   return new Promise((resolve, reject) => {
    //     login(username, userInfo.password).then(response => {
    //       const data = response.data;
    //       this.user = 'userAdmin';
    //       const tokenStr = data.tokenHead+data.token
    //       setToken(tokenStr)
    //       commit('SET_TOKEN', tokenStr)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password, userInfo.loginType, userInfo.userType).then(response => {
          const data = response.data;
          this.user = 'userAdmin';
          const tokenStr = data.tokenHead+data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 商家登录
    Logins({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        logins(username, userInfo.password, userInfo.type).then(response => {
          const data = response.data
          this.user = 'userSeller'
          const tokenStr = data.tokenHead+data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },





    GetInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
        //管理员
        getInfo().then(response => {
          const data = response.data
          // const buttons = data
          // const buttonAuthList = []
          // //按钮
          // buttons.forEach(res => {
          //   console.log(res);
          //   if (res.permiList) {
          //     buttonAuthList.push(res.permiList)
          //   }
          // })
          // const buttons = response.data
          this.type =  response.data.type
          if (data.roles && data.roles.length > 0 ) {
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }


          for (let i = 0; i < data.menus.length; i++) {
            if (data.menus[i].title == '大厅开票') {
              commit('SET_ID', data.menus[i].title);
              // console.log(data.menus[i].title);
            }
          }

          // commit('SET_ID', data.username);
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.imgfile)
          commit('SET_ROLES', data.roles)
          commit('SET_BUTTONS', data.permiList) //按钮
          resolve(response)
        }).catch(error => {
          reject(error)
        });

    })
  },


    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_BUTTONS', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_BUTTONS', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js